import { render } from "./IconRemixicon.vue?vue&type=template&id=218739fe"
import script from "./IconRemixicon.vue?vue&type=script&lang=js"
export * from "./IconRemixicon.vue?vue&type=script&lang=js"

import exportComponent from "/mnt/d/git/workshop/social-friendsquads/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__